export interface IArtistDB {
  id: number;

  name: string;

  cover: Blob | File | null;

  biography?: string;

  slug: string;

  thumbnail?: Blob;
}

export type IArtistsDB = IArtistDB[];

export interface IAlbumDB {
  id?: number;

  name: string;

  cover: Blob;

  slug: string;

  artistId: number;

  year?: number;

  label?: string;

  genre?: string[];
}

export type IAlbumsDB = IAlbumDB[];

export interface ITrackDB {
  id: number;

  name: string;

  source: string | Blob;

  slug: string;

  order: number;

  artistId: number;

  albumId: number;

  metadata: ITrackMetadata;
}

export type ITracksDB = ITrackDB[];

export interface ITrackMetadata {
  title?: string;

  artist?: string;

  album?: string;

  genre?: string[];

  year?: number;

  bitrate?: number;

  duration?: number;

}

export interface IPlaylistProgressTime {
  duration: number;

  progress: number;

  currentTime: number;
}

export enum ITypeMedia {
  video = "video",

  image = "image",

  camera = "camera",

  display = "display",

  videoExternal = "videoExternal",

  browser = "browser",

  remoteDevice = "remoteDevice",
}
